import { Component, EventEmitter, Output, Input, OnChanges, SimpleChanges } from '@angular/core'
import { FormBuilder, FormGroup, } from '@angular/forms'
import { Observable } from 'rxjs'
import { QuestionTypeView, QuestionViewService, IQuestionAnswer } from '..'
import { RadioPrompt } from '../../../../../forms/models'
import { Question } from '../../../../data/models'
import { IFormOption } from '../../../../forms/services'
@Component({
  selector: 'mp-two-part-analysis-question-view',
  templateUrl: './two-part-analysis-question-view.html',
  styleUrls: ['./two-part-analysis-question-view.scss']
})
export class TwoPartAnalysisQuestionViewComponent extends QuestionTypeView implements OnChanges {
  @Input() public answerChoicePrompt: RadioPrompt
  @Input() public question: Question
  public options: Observable<IFormOption[]>
  public reviewMode: boolean = false
  public customAnswerChoiceGroupFormGroup: FormGroup
  public firstGroupOptions: IFormOption[] = []
  public secondGroupOptions:IFormOption[] = []
  @Output() public optionSelected: EventEmitter<IQuestionAnswer> = new EventEmitter()

  public constructor(
    private _formBuilder: FormBuilder,
    public _questionViewService: QuestionViewService
  ) { super(_questionViewService) }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.question) {
      this.customAnswerChoiceGroupFormGroup = this._formBuilder.group({})
      const group1Control = this._formBuilder.control(this.getAnswerChoicePrompt(0).value, this.getAnswerChoicePrompt(0).validators)
      const group2Control = this._formBuilder.control(this.getAnswerChoicePrompt(1).value, this.getAnswerChoicePrompt(1).validators)
      this.customAnswerChoiceGroupFormGroup.setControl('acg1', group1Control)
      this.customAnswerChoiceGroupFormGroup.setControl('acg2', group2Control)

      Observable.forkJoin(
        this.getAnswerChoicePrompt<RadioPrompt>(0).options,
        this.getAnswerChoicePrompt<RadioPrompt>(1).options
      ).subscribe((results) => {
        this.firstGroupOptions = results[0]
        this.secondGroupOptions = results[1]
      })
    }
  }

  public get firstGroupText() {
    return this.question.answerChoiceGroups[0].getLabel('text').value
  }

  public get secondGroupText(){
    return this.question.answerChoiceGroups[1].getLabel('text').value
  }

  public selectOption(value: string, answerChoiceFormGroup: FormGroup) {
    if (this.reviewMode || answerChoiceFormGroup.disabled) {
      return
    }
     answerChoiceFormGroup.setValue({answerChoice: value})
    this._questionViewService.questionAnswered.emit(this.getQuestionAnswers())
  }

  public isSelected(option, formGroup) {
    return formGroup.value.answerChoice === option.value
  }

  public isCorrect(option): boolean {
    return this._questionViewService.question.isAnswerChoiceCorrect(option.value)
  }

}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/components/question-view/two-part-analysis-question-view/two-part-analysis-question-view.component.ts